const subNavBarcategory = [
  {
    categoriesName: "Fasion",
    image:
      "https://png.pngtree.com/png-clipart/20220502/original/pngtree-indian-wedding-couple-outfits-traditional-lehenga-and-indo-western-for-bride-png-image_7650932.png",
    categories: [
      {
        category: "Men's Fashion",
        products: [
          {
            id: 1,
            name: "T-Shirt",
          },
          {
            id: 2,
            name: "Shirt",
          },
          {
            id: 3,
            name: "T-Shirt 3",
          },

          {
            id: 6,
            name: "Jeans",
          },
          {
            id: 7,
            name: "Formal jeans",
          },
          {
            id: 8,
            name: "Baniyans",
          },
          {
            id: 9,
            name: "Inner Wears",
          },

          {
            id: 11,
            name: "Shoes",
          },
          {
            id: 12,
            name: "Casual Shoes",
          },
          {
            id: 13,
            name: "Watches",
          },
          {
            id: 14,
            name: "Chains",
          },
          {
            id: 15,
            name: "Gogals",
          },
          {
            id: 16,
            name: "Jacket",
          },
        ],
      },
      {
        category: "Women's Fashion",
        products: [
          {
            id: 1,
            name: "Dress",
          },
          {
            id: 2,
            name: "Saaree",
          },
          {
            id: 3,
            name: "Party Wears",
          },
          {
            id: 4,
            name: "Nigth Wears",
          },
          {
            id: 5,
            name: "Sandales",
          },
          {
            id: 6,
            name: "Inner Wears",
          },
          {
            id: 7,
            name: "Blouse",
          },
          {
            id: 8,
            name: "Nekles",
          },
          {
            id: 9,
            name: "Lipistics",
          },
          {
            id: 10,
            name: "Kajals",
          },
          {
            id: 11,
            name: "Skirt",
          },

          {
            id: 16,
            name: "Shoes ",
          },
        ],
      },
      {
        category: "Kids' Fashion",
        products: [
          {
            id: 1,
            name: "Kids T-Shirt ",
          },
          {
            id: 2,
            name: "Kids Shirt",
          },
          {
            id: 3,
            name: "Inner Ware",
          },
          {
            id: 4,
            name: "Kids Winter Clothes",
          },
          {
            id: 5,
            name: "Gogales",
          },
          {
            id: 6,
            name: "Jeans",
          },

          {
            id: 11,
            name: "Kids Shoes ",
          },

          {
            id: 16,
            name: "Kids Jacket ",
          },
        ],
      },
      {
        category: "Elderly Fashion",
        products: [
          {
            id: 1,
            name: " Shirt",
          },
          {
            id: 2,
            name: "T-Shirt ",
          },
          {
            id: 3,
            name: "Caps",
          },

          {
            id: 6,
            name: "Elderly Pants ",
          },

          {
            id: 11,
            name: "Elderly Shoes ",
          },

          {
            id: 16,
            name: "Elderly Jacket ",
          },
        ],
      },
    ],
  },
  {
    categoriesName: "Electronics",
    image:
      "https://png.pngtree.com/png-clipart/20190614/original/pngtree-isometric-electronic-devices-collection-png-image_3791895.jpg",
    categories: [
      {
        category: "Mobile Phones",
        products: [
          {
            id: 1,
            name: "iPhone 12",
          },
          {
            id: 2,
            name: "Samsung Galaxy S21",
          },
          {
            id: 3,
            name: "Google Pixel 5",
          },
          {
            id: 4,
            name: "OnePlus 9 Pro",
          },
          {
            id: 5,
            name: "Xiaomi Mi 11",
          },
          {
            id: 6,
            name: "Sony Xperia 1 III",
          },
          {
            id: 7,
            name: "LG Velvet 5G",
          },
          {
            id: 8,
            name: "Motorola Edge+",
          },
          {
            id: 9,
            name: "Nokia 8.3 5G",
          },
          {
            id: 10,
            name: "Huawei P40 Pro",
          },
          {
            id: 11,
            name: "Oppo Find X3 Pro",
          },
          {
            id: 12,
            name: "Vivo X60 Pro+",
          },
          {
            id: 13,
            name: "Realme 8 Pro",
          },
          {
            id: 14,
            name: "Lenovo Legion Phone Duel 2",
          },
          {
            id: 15,
            name: "ASUS ROG Phone 5",
          },
        ],
      },
      {
        category: "Laptops",
        products: [
          {
            id: 1,
            name: "MacBook Pro",
          },
          {
            id: 2,
            name: "Dell XPS 13",
          },
          {
            id: 3,
            name: "HP Spectre x360",
          },
          {
            id: 4,
            name: "Lenovo ThinkPad X1 Carbon",
          },
          {
            id: 5,
            name: "ASUS ZenBook 14",
          },
          {
            id: 6,
            name: "Acer Swift 5",
          },
          {
            id: 7,
            name: "Microsoft Surface Laptop 4",
          },
          {
            id: 8,
            name: "Razer Blade 15",
          },
          {
            id: 9,
            name: "Alienware m15 R4",
          },
          {
            id: 10,
            name: "LG Gram 17",
          },
          {
            id: 11,
            name: "Samsung Galaxy Book Pro",
          },
          {
            id: 12,
            name: "MSI GS66 Stealth",
          },
          {
            id: 13,
            name: "Huawei MateBook X Pro",
          },
          {
            id: 14,
            name: "Google Pixelbook Go",
          },
          {
            id: 15,
            name: "Acer Predator Helios 300",
          },
        ],
      },
      {
        category: "TVs",
        products: [
          {
            id: 1,
            name: "Samsung QLED Q80A",
          },
          {
            id: 2,
            name: "LG OLED CX",
          },
          {
            id: 3,
            name: "Sony BRAVIA X90J",
          },
          {
            id: 4,
            name: "TCL 6-Series",
          },
          {
            id: 5,
            name: "Vizio OLED",
          },
          {
            id: 6,
            name: "Hisense U8G",
          },
          {
            id: 7,
            name: "Samsung Crystal UHD 7 Series",
          },
          {
            id: 8,
            name: "LG NanoCell NANO90",
          },
          {
            id: 9,
            name: "Sony A8H OLED",
          },
          {
            id: 10,
            name: "Toshiba 4K UHD Smart Fire TV",
          },
          {
            id: 11,
            name: "Philips OLED 805",
          },
          {
            id: 12,
            name: "Panasonic JZ2000 OLED",
          },
          {
            id: 13,
            name: "Sharp Aquos R5G",
          },
          {
            id: 14,
            name: "Hisense A6G",
          },
          {
            id: 15,
            name: "Vizio P-Series Quantum X",
          },
        ],
      },
      {
        category: "Mobile Accessories",
        products: [
          {
            id: 1,
            name: "Wireless Earphones",
          },
          {
            id: 2,
            name: "Power Banks",
          },
          {
            id: 3,
            name: "Phone Cases",
          },
          {
            id: 4,
            name: "Screen Protectors",
          },
          {
            id: 5,
            name: "Charging Cables",
          },
          {
            id: 6,
            name: "Car Mounts",
          },
          {
            id: 7,
            name: "Bluetooth Speakers",
          },
          {
            id: 8,
            name: "Mobile Holders",
          },
          {
            id: 9,
            name: "Selfie Sticks",
          },
          {
            id: 10,
            name: "Mobile Lens Kits",
          },
          {
            id: 11,
            name: "PopSockets",
          },
          {
            id: 12,
            name: "Smartphone Gloves",
          },
          {
            id: 13,
            name: "Mobile Game Controllers",
          },
          {
            id: 14,
            name: "Wireless Chargers",
          },
          {
            id: 15,
            name: "Phone Stand",
          },
        ],
      },
    ],
  },
  {
    categoriesName: "IceCream",
    image:
      "https://previews.123rf.com/images/imagestore/imagestore1411/imagestore141100063/33751288-ice-cream-scoops-in-bowl-on-white-background.jpg",
    categories: [
      {
        category: "Cold Drinks",
        products: [
          {
            name: "Sprite",
          },
          {
            name: "Coca-Cola",
          },
          {
            name: "Pepsi",
          },
          {
            name: "Mountain Dew",
          },
          {
            name: "Fanta",
          },
          {
            name: "7UP",
          },
          {
            name: "Mirinda",
          },
          {
            name: "Thums Up",
          },
          {
            name: "Limca",
          },
          {
            name: "Maaza",
          },
        ],
      },

      {
        category: "Ice Creams",
        products: [
          {
            name: "Amul",
          },
          {
            name: "Kwality Walls",
          },
          {
            name: "Havmor",
          },
          {
            name: "Mother Dairy",
          },
          {
            name: "Vadilal",
          },
          {
            name: "Baskin-Robbins",
          },
          {
            name: "Haagen-Dazs",
          },
          {
            name: "Ben & Jerry's",
          },
          {
            name: "Magnum",
          },
          {
            name: "Dairy Queen",
          },
        ],
      },
      {
        category: "Cones",
        products: [
          {
            name: "Chocolate Cone",
          },
          {
            name: "Vanilla Cone",
          },
          {
            name: "Strawberry Cone",
          },
          {
            name: "Mint Cone",
          },
          {
            name: "Butter Pecan Cone",
          },
          {
            name: "Coffee Cone",
          },
          {
            name: "Caramel Cone",
          },
          {
            name: "Cookies and Cream Cone",
          },
          {
            name: "Mango Cone",
          },
          {
            name: "Pistachio Cone",
          },
        ],
      },
    ],
  },
  {
    categoriesName: "Vegetables",
    image:
      "https://thumbs.dreamstime.com/b/vegetables-white-grocery-bag-isolated-assorted-watercolor-painting-background-47257711.jpg",
    categories: [
      {
        category: "Leafy Greens",
        products: [
          { name: "Spinach" },
          { name: "Kale" },
          { name: "Lettuce" },
          { name: "Arugula" },
          { name: "Collard Greens" },
          { name: "Swiss Chard" },
          { name: "Mustard Greens" },
          { name: "Watercress" },
          { name: "Bok Choy" },
          { name: "Cabbage" },
        ],
      },
      {
        category: "Root Vegetables",
        products: [
          { name: "Carrots" },
          { name: "Potatoes" },
          { name: "Sweet Potatoes" },
          { name: "Beets" },
          { name: "Radishes" },
          { name: "Turnips" },
          { name: "Parsnips" },
          { name: "Yams" },
          { name: "Onions" },
          { name: "Garlic" },
        ],
      },
      {
        category: "Cruciferous Vegetables",
        products: [
          { name: "Broccoli" },
          { name: "Cauliflower" },
          { name: "Cabbage" },
          { name: "Brussels Sprouts" },
          { name: "Kohlrabi" },
          { name: "Bok Choy" },
          { name: "Rutabaga" },
          { name: "Collard Greens" },
          { name: "Turnips" },
          { name: "Kale" },
        ],
      },
      {
        category: "Allium Vegetables",
        products: [
          { name: "Onions" },
          { name: "Garlic" },
          { name: "Leeks" },
          { name: "Shallots" },
          { name: "Scallions" },
          { name: "Chives" },
          { name: "Spring Onions" },
          { name: "Red Onions" },
          { name: "White Onions" },
          { name: "Yellow Onions" },
        ],
      },
      {
        category: "Nightshade Vegetables",
        products: [
          { name: "Tomatoes" },
          { name: "Bell Peppers" },
          { name: "Eggplant" },
          { name: "Potatoes" },
          { name: "Chili Peppers" },
          { name: "Paprika" },
          { name: "Cayenne Pepper" },
          { name: "Jalapeno Peppers" },
          { name: "Banana Peppers" },
          { name: "Poblano Peppers" },
        ],
      },
    ],
  },
  {
    categoriesName: "Grocery",
    image:
      "https://thumbs.dreamstime.com/b/shopping-cart-full-dairy-grocery-products-isolated-over-white-background-35477050.jpg",
    categories: [
      {
        category: "Oils",
        products: [
          {
            name: "Olive Oil",
          },
          {
            name: "Coconut Oil",
          },
          {
            name: "Sunflower Oil",
          },
          {
            name: "Canola Oil",
          },
          {
            name: "Sesame Oil",
          },
          {
            name: "Peanut Oil",
          },
          {
            name: "Vegetable Oil",
          },
          {
            name: "Corn Oil",
          },
          {
            name: "Grapeseed Oil",
          },
          {
            name: "Avocado Oil",
          },
        ],
      },
      {
        category: "Grains",
        products: [
          {
            name: "Rice",
          },
          {
            name: "Wheat",
          },
          {
            name: "Oats",
          },
          {
            name: "Barley",
          },
          {
            name: "Quinoa",
          },
          {
            name: "Buckwheat",
          },
          {
            name: "Cornmeal",
          },
          {
            name: "Millet",
          },
          {
            name: "Couscous",
          },
          {
            name: "Farro",
          },
        ],
      },
      {
        category: "Spices",
        products: [
          {
            name: "Cumin",
          },
          {
            name: "Turmeric",
          },
          {
            name: "Coriander",
          },
          {
            name: "Cinnamon",
          },
          {
            name: "Paprika",
          },
          {
            name: "Black Pepper",
          },
          {
            name: "Cardamom",
          },
          {
            name: "Cloves",
          },
          {
            name: "Ginger",
          },
          {
            name: "Nutmeg",
          },
        ],
      },
      {
        category: "Kitchen Utensils",
        products: [
          {
            name: "Cutting Board",
          },
          {
            name: "Chef Knife",
          },
          {
            name: "Measuring Cups",
          },
          {
            name: "Mixing Bowls",
          },
          {
            name: "Spatula",
          },
          {
            name: "Whisk",
          },
          {
            name: "Tongs",
          },
          {
            name: "Peeler",
          },
          {
            name: "Grater",
          },
          {
            name: "Colander",
          },
        ],
      },
    ],
  },
  {
    categoriesName: "Beauty Products",
    image:
      "https://st2.depositphotos.com/4320929/11436/v/950/depositphotos_114364428-stock-illustration-unusual-creative-makeup-set.jpg",
    categories: [
      {
        category: "Skincare",
        products: [
          {
            name: "Moisturizer",
          },
          {
            name: "Cleanser",
          },
          {
            name: "Toner",
          },
          {
            name: "Serum",
          },
          {
            name: "Face Mask",
          },
          {
            name: "Eye Cream",
          },
          {
            name: "Sunscreen",
          },
          {
            name: "Exfoliator",
          },
          {
            name: "Night Cream",
          },
          {
            name: "Lip Balm",
          },
        ],
      },
      {
        category: "Makeup",
        products: [
          {
            name: "Foundation",
          },
          {
            name: "Concealer",
          },
          {
            name: "Blush",
          },
          {
            name: "Eyeshadow",
          },
          {
            name: "Mascara",
          },
          {
            name: "Eyeliner",
          },
          {
            name: "Lipstick",
          },
          {
            name: "Lip Gloss",
          },
          {
            name: "Bronzer",
          },
          {
            name: "Highlighter",
          },
        ],
      },
      {
        category: "Haircare",
        products: [
          {
            name: "Shampoo",
          },
          {
            name: "Conditioner",
          },
          {
            name: "Hair Mask",
          },
          {
            name: "Hair Oil",
          },
          {
            name: "Hair Serum",
          },
          {
            name: "Hair Styling Spray",
          },
          {
            name: "Hair Gel",
          },
          {
            name: "Hair Mousse",
          },
          {
            name: "Heat Protectant",
          },
          {
            name: "Hair Brushes",
          },
        ],
      },
      {
        category: "Nailcare",
        products: [
          {
            name: "Nail Polish",
          },
          {
            name: "Nail Polish Remover",
          },
          {
            name: "Nail File",
          },
          {
            name: "Cuticle Oil",
          },
          {
            name: "Nail Strengthener",
          },
          {
            name: "Base Coat",
          },
          {
            name: "Top Coat",
          },
          {
            name: "Nail Art Kit",
          },
          {
            name: "Nail Stickers",
          },
          {
            name: "Nail Buffer",
          },
        ],
      },
    ],
  },
  {
    categoriesName: "Furniture",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTCdlc_Fqc1d1BXhq07j5eOH6Lo1NMFBOr0w&usqp=CAU",
    categories: [
      {
        category: "Living Room",
        products: [
          {
            name: "Sofa",
          },
          {
            name: "Coffee Table",
          },
          {
            name: "TV Stand",
          },
          {
            name: "Bookshelf",
          },
          {
            name: "Armchair",
          },
          {
            name: "Side Table",
          },
          {
            name: "Console Table",
          },
          {
            name: "Ottoman",
          },
          {
            name: "Floor Lamp",
          },
          {
            name: "Rug",
          },
        ],
      },
      {
        category: "Bedroom",
        products: [
          {
            name: "Bed Frame",
          },
          {
            name: "Mattress",
          },
          {
            name: "Dresser",
          },
          {
            name: "Nightstand",
          },
          {
            name: "Wardrobe",
          },
          {
            name: "Vanity Table",
          },
          {
            name: "Bedside Lamp",
          },
          {
            name: "Chest of Drawers",
          },
          {
            name: "Mirror",
          },
          {
            name: "Bedding Set",
          },
        ],
      },
      {
        category: "Dining Room",
        products: [
          {
            name: "Dining Table",
          },
          {
            name: "Chairs",
          },
          {
            name: "Buffet Cabinet",
          },
          {
            name: "Bar Stools",
          },
          {
            name: "China Cabinet",
          },
          {
            name: "Sideboard",
          },
          {
            name: "Display Shelf",
          },
          {
            name: "Dining Bench",
          },
          {
            name: "Bar Cart",
          },
          {
            name: "Wine Rack",
          },
        ],
      },
      {
        category: "Home Office",
        products: [
          {
            name: "Desk",
          },
          {
            name: "Office Chair",
          },
          {
            name: "Bookcase",
          },
          {
            name: "File Cabinet",
          },
          {
            name: "Shelving Unit",
          },
          {
            name: "Desk Lamp",
          },
          {
            name: "Office Accessories",
          },
          {
            name: "Desk Organizer",
          },
          {
            name: "Bulletin Board",
          },
          {
            name: "Computer Stand",
          },
        ],
      },
    ],
  },
  {
    categoriesName: "Toys",
    image:
      "https://png.pngtree.com/png-clipart/20220130/original/pngtree-cartoon-building-block-lego-toy-car-png-image_7242381.png",
    categories: [
      {
        category: "Action Figures",
        products: [
          {
            name: "Superhero Figures",
          },
          {
            name: "Anime Figures",
          },
          {
            name: "Movie Characters",
          },
          {
            name: "Sports Figures",
          },
          {
            name: "Animal Figures",
          },
          {
            name: "Robot Figures",
          },
          {
            name: "Historical Figures",
          },
          {
            name: "Fantasy Figures",
          },
          {
            name: "Vehicles and Playsets",
          },
          {
            name: "Collectible Figures",
          },
        ],
      },
      {
        category: "Dolls and Accessories",
        products: [
          {
            name: "Fashion Dolls",
          },
          {
            name: "Baby Dolls",
          },
          {
            name: "Barbie Dolls",
          },
          {
            name: "Interactive Dolls",
          },
          {
            name: "Dollhouses",
          },
          {
            name: "Doll Clothing and Accessories",
          },
          {
            name: "Doll Furniture",
          },
          {
            name: "Doll Strollers and Carriers",
          },
          {
            name: "Doll Playsets",
          },
          {
            name: "Doll Care and Grooming",
          },
        ],
      },
      {
        category: "Board Games",
        products: [
          {
            name: "Strategy Games",
          },
          {
            name: "Family Games",
          },
          {
            name: "Card Games",
          },
          {
            name: "Educational Games",
          },
          {
            name: "Party Games",
          },
          {
            name: "Classic Games",
          },
          {
            name: "Word Games",
          },
          {
            name: "Puzzle Games",
          },
          {
            name: "Trivia Games",
          },
          {
            name: "Cooperative Games",
          },
        ],
      },
      {
        category: "Outdoor Toys",
        products: [
          {
            name: "Sports Equipment",
          },
          {
            name: "Bikes and Ride-Ons",
          },
          {
            name: "Water Toys",
          },
          {
            name: "Playhouses",
          },
          {
            name: "Sand and Beach Toys",
          },
          {
            name: "Inflatable Bouncers",
          },
          {
            name: "Swing Sets",
          },
          {
            name: "Trampolines",
          },
          {
            name: "Outdoor Games",
          },
          {
            name: "Kites",
          },
        ],
      },
      {
        category: "Puzzles",
        products: [
          {
            name: "Jigsaw Puzzles",
          },
          {
            name: "Brain Teasers",
          },
          {
            name: "Wooden Puzzles",
          },
          {
            name: "3D Puzzles",
          },
          {
            name: "Floor Puzzles",
          },
          {
            name: "Puzzle Sets",
          },
          {
            name: "Puzzle Accessories",
          },
          {
            name: "Educational Puzzles",
          },
          {
            name: "Customizable Puzzles",
          },
          {
            name: "Magnetic Puzzles",
          },
        ],
      },
    ],
  },
  {
    categoriesName: "Appliances",
    image:
      "https://static.vecteezy.com/system/resources/previews/001/844/657/non_2x/modern-tv-design-illustration-isolated-on-white-background-free-vector.jpg",
    categories: [
      {
        category: "Televisions",
        products: [
          { name: "Smart TVs" },
          { name: "LED TVs" },
          { name: "OLED TVs" },
          { name: "QLED TVs" },
          { name: "4K TVs" },
          { name: "Curved TVs" },
          { name: "Android TVs" },
          { name: "LCD TVs" },
          { name: "Plasma TVs" },
          { name: "HD TVs" },
        ],
      },
      {
        category: "Refrigerators",
        products: [
          { name: "Single Door Refrigerators" },
          { name: "Double Door Refrigerators" },
          { name: "Triple Door Refrigerators" },
          { name: "Side-by-Side Refrigerators" },
          { name: "French Door Refrigerators" },
          { name: "Mini Fridges" },
          { name: "Convertible Refrigerators" },
          { name: "Inverter Refrigerators" },
          { name: "Frost-Free Refrigerators" },
          { name: "Direct Cool Refrigerators" },
        ],
      },
      {
        category: "Air Conditioners",
        products: [
          { name: "Split ACs" },
          { name: "Window ACs" },
          { name: "Inverter ACs" },
          { name: "Portable ACs" },
          { name: "Tower ACs" },
          { name: "Cassette ACs" },
          { name: "Floor Standing ACs" },
          { name: "Smart ACs" },
          { name: "WiFi-enabled ACs" },
          { name: "5-Star Rated ACs" },
        ],
      },
      {
        category: "Washing Machines",
        products: [
          { name: "Front Load Washing Machines" },
          { name: "Top Load Washing Machines" },
          { name: "Semi-Automatic Washing Machines" },
          { name: "Fully Automatic Washing Machines" },
          { name: "Fully Automatic Front Load Washing Machines" },
          { name: "Fully Automatic Top Load Washing Machines" },
          { name: "Inverter Washing Machines" },
          { name: "Smart Washing Machines" },
          { name: "WiFi-enabled Washing Machines" },
          { name: "6 kg Capacity Washing Machines" },
        ],
      },
      {
        category: "Kitchen Appliances",
        products: [
          { name: "Mixer Grinders" },
          { name: "Juicers" },
          { name: "Food Processors" },
          { name: "Induction Cooktops" },
          { name: "Gas Stoves" },
          { name: "Electric Kettles" },
          { name: "Toasters" },
          { name: "Microwave Ovens" },
          { name: "Oven Toaster Grills (OTGs)" },
          { name: "Coffee Makers" },
        ],
      },
    ],
  },
];

export default subNavBarcategory;
